import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Stack } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import ForgotAddEmailForm from './components/ForgotAddEmailForm'
import ForgotAddCodeForm from './components/ForgotAddCodeForm'
import ForgotAddPasswordForm from './components/ForgotAddPasswordForm'

export const ForgotPassword = () => {
  const { t } = useTranslation()
  const [showFormCode, setShowFormCode] = useState(false)
  const [showFormPassword, setShowFormPassword] = useState(false)
  const [username, setUsername] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [id, setId] = useState<string>('')

  const handleAddEmailWithSuccess = (username: string) => {
    setUsername(username)
    setShowFormCode(true)
  }

  const handleAddCodeWithSuccess = (code: string, id: string) => {
    setShowFormCode(false)
    setShowFormPassword(true)
    setCode(code)
    setId(id)
  }

  return (
    <>
      <Helmet>
        <title> Forgot | DWF </title>
      </Helmet>
      <Stack>
        {(!showFormCode && !showFormPassword) &&
          <ForgotAddEmailForm onSuccess={handleAddEmailWithSuccess} />
        }
        {showFormCode &&
          <ForgotAddCodeForm username={username} onSuccess={handleAddCodeWithSuccess} />
        }
        {showFormPassword &&
          <ForgotAddPasswordForm code={code} id={id} />
        }
      </Stack>
      <Stack alignItems="center" pt={2}>
        <Link href="/signIn">{t('forgot.buttonBack')}</Link>
      </Stack>
    </>
  )
}
